module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', [_vm._v("404")]), _c('p', [_vm._v("当前页面不存在")]), _c('sms_button', {
    attrs: {
      "url": "/",
      "link": "link"
    }
  }, [_vm._v("回到首页")]), _c('p', [_vm._v(_vm._s(_vm.countdown) + " S 后返回首页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-389beb1e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = 1004
// module chunks = 1